import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "../api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("dnya_token");
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
    } catch {
      localStorage.removeItem("dnya_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me check if returning from OAuth callback - callback will set token
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = (token, userObj) => {
    localStorage.setItem("dnya_token", token);
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("dnya_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={useMemo(() => ({ user, setUser, loading, login, logout, refresh }), [user, loading, login, logout, refresh])}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
